import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";

import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyCok-2wXQg6f-aoZG88qRsRzaA5Z05mz9Q",
  authDomain: "zillibets-383b0.firebaseapp.com",
  projectId: "zillibets-383b0",
  storageBucket: "zillibets-383b0.firebasestorage.app",
  messagingSenderId: "351753121565",
  appId: "1:351753121565:web:890410ed2a3b0c2387bbf4",
  measurementId: "G-BW8CZB5DWL",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const appleProvider = new OAuthProvider("apple.com");
appleProvider.addScope("email");
appleProvider.addScope("name");

export { auth, provider, appleProvider };
